module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.curInput.interface,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "接口方式",
      "prop": "method"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.interface.method),
      expression: "curInput.interface.method"
    }],
    staticClass: "radio",
    attrs: {
      "label": "GET"
    },
    domProps: {
      "value": (_vm.curInput.interface.method)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.method = $event
      }
    }
  }, [_vm._v("GET")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.interface.method),
      expression: "curInput.interface.method"
    }],
    staticClass: "radio",
    attrs: {
      "label": "POST"
    },
    domProps: {
      "value": (_vm.curInput.interface.method)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.method = $event
      }
    }
  }, [_vm._v("POST")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接口地址",
      "prop": "api_url"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.interface.api_url),
      expression: "curInput.interface.api_url",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.curInput.interface.api_url)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.api_url = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关键传入参数名"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.interface.key),
      expression: "curInput.interface.key"
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.curInput.interface.key)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.key = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("也就是用户输入的那个输入框的参数名是什么，例如:vin")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接口传入参数"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.interface.data),
      expression: "curInput.interface.data"
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.curInput.interface.data)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.data = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("用':'写键值对，多参数用',' 隔开，例如:key:123456,appid:123")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返回状态参数"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.interface.status),
      expression: "curInput.interface.status"
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.curInput.interface.status)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.status = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("用'/'作为多维数组分隔符,例如:ret/status")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提示语配置"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "data": _vm.curInput.interface.error_msg
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "状态码"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.error_code),
            expression: "scope.row.error_code"
          }],
          attrs: {
            "placeholder": "返回的状态码"
          },
          domProps: {
            "value": (scope.row.error_code)
          },
          on: {
            "input": function($event) {
              scope.row.error_code = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "提示语"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.msg),
            expression: "scope.row.msg"
          }],
          attrs: {
            "placeholder": "返回的提示语"
          },
          domProps: {
            "value": (scope.row.msg)
          },
          on: {
            "input": function($event) {
              scope.row.msg = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "60"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteRow(scope.$index, _vm.curInput.interface.error_msg)
            }
          }
        }, [_vm._v("\n                删除\n              ")])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "m-t-5",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addErrorStatus
    }
  }, [_vm._v("增加一个")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "正常参数值"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.interface.success_status),
      expression: "curInput.interface.success_status"
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.curInput.interface.success_status)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.success_status = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返回参数内容"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.interface.content),
      expression: "curInput.interface.content"
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.curInput.interface.content)
    },
    on: {
      "input": function($event) {
        _vm.curInput.interface.content = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("用'/'作为多维数组分隔符,例如:ret/info")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返回参数内容对应控件"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "data": _vm.curInput.interface.set_field
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "返回的参数名"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.param),
            expression: "scope.row.param"
          }],
          attrs: {
            "placeholder": "返回的参数名"
          },
          domProps: {
            "value": (scope.row.param)
          },
          on: {
            "input": function($event) {
              scope.row.param = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "对应本表单的字段控件"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.fieldname),
            expression: "scope.row.fieldname"
          }],
          attrs: {
            "placeholder": "请选择"
          },
          domProps: {
            "value": (scope.row.fieldname)
          },
          on: {
            "visible-change": function($event) {
              _vm.getFieeldName(scope.row)
            },
            "input": function($event) {
              scope.row.fieldname = $event
            }
          }
        }, _vm._l((_vm.fieldNames), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "60"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteRow(scope.$index, _vm.curInput.interface.set_field)
            }
          }
        }, [_vm._v("\n                删除\n              ")])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "m-t-5",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addField
    }
  }, [_vm._v("增加一个")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39def765!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/obtainConfig.vue
// module id = 1825
// module chunks = 2